<template>
    <div class="layout--main" :class="[navbarClasses]">

        <vx-sidebar :sidebarItems="sidebarItems" :logo="require('@/assets/images/logo/logo2.png')" title="Revenda"
                    parent=".layout--main"/>

        <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">

            <div id="content-overlay"></div>

            <div class="content-wrapper">

                <Navbar :navbarColor="navbarColor" :class="[{'text-white': isNavbarDark && !isThemeDark}, {'text-base': !isNavbarDark && isThemeDark}]"/>
                <div class="vx-navbar-wrapper h-24 p-4" style="margin-top: 75px; z-index:10000; background-color:rgb(248, 248, 248);" v-if="$route.meta.breadcrumb">
                    <transition :name="routerTransition">
                        <div class="mt-2">
                            <div class="w-full flex justify-between h-auto">
                                <div class="w-1/2 h-full flex">
                                    <div class="router-header flex flex-wrap items-center mb-6"
                                         v-if="$route.meta.breadcrumb || $route.meta.pageTitle">
                                        <div class="content-area__heading"
                                             :class="{'pr-4 border-0 md:border-r border-t-0 border-b-0 border-l-0 border-solid border-grey-light' : $route.meta.breadcrumb}">
                                            <h2 class="mb-1">{{ routeTitle }}</h2>
                                        </div>
                                        <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb"/>
                                    </div>
                                </div>
                                <div class="w-1/2 h-full flex justify-end">
                                    <div v-if="$route.meta.create" >
                                        <vs-button :to="$route.meta.create.url">{{$route.meta.create.buttonTitle}}</vs-button>
                                    </div>
                                    <DateRangePicker
                                            v-if="$route.meta.showDateRangePicker"
                                            class="ml-auto md:block hidden"
                                            :start-date="startDate"
                                            :end-date="endDate"
                                            @update="payload => updateDateRange(payload)" ></DateRangePicker>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
                <div class="router-view">
                    <div class="router-content" :class="{'mt-0': navbarType === 'hidden'}" :style="{marginTop: $route.meta.breadcrumb ? '10rem' : ''}">
                        <div class="content-area__content">
                            <transition :name="routerTransition" mode="out-in">
                                <router-view @changeRouteTitle="changeRouteTitle"></router-view>
                            </transition>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import themeConfig from '@/../themeConfig.js';
    import sidebarItems from "@/layouts/components/vx-sidebar/sidebarItems.js";
    import {mapActions, mapGetters} from "vuex";

    export default {
        data() {
            return {
                navbarType: themeConfig.navbarType || 'floating',
                navbarColor: themeConfig.navbarColor || '#fff',
                footerType: themeConfig.footerType || 'static',
                routerTransition: themeConfig.routerTransition || 'none',
                isNavbarDark: false,
                routeTitle: this.$route.meta.pageTitle,
                sidebarItems: sidebarItems,
                disableCustomizer: themeConfig.disableCustomizer,
                windowWidth: window.innerWidth, //width of windows
                startDate: new Date(),
                endDate: new Date(),
            }
        },
        watch: {
            '$route'() {
                this.routeTitle = this.$route.meta.pageTitle;
            },
            isThemeDark(val) {
                if (this.navbarColor === "#fff" && val) {
                    this.updateNavbarColor("#10163a")
                } else {
                    this.updateNavbarColor("#fff")
                }
            },
            daterange: {
                handler() {
                    this.setDates();
                },
                deep: true
            }
        },
        computed: {
            ...mapGetters(['isThemeDark', 'sidebarWidth', 'bodyOverlay', 'daterange']),
            contentAreaClass() {
                if (this.sidebarWidth === "default") return "content-area-default";
                else if (this.sidebarWidth === "reduced") return "content-area-reduced";
                else if (this.sidebarWidth) return "content-area-full"
            },
            navbarClasses() {
                return {
                    'navbar-hidden': this.navbarType === 'hidden',
                    'navbar-sticky': this.navbarType === 'sticky',
                    'navbar-static': this.navbarType === 'static',
                    'navbar-floating': this.navbarType === 'floating',
                }
            },
        },
        methods: {
            ...mapActions(['toggleIsSidebarActive', 'updateSidebarWidth', 'updateDateRange']),
            changeRouteTitle(title) {
                this.routeTitle = title;
            },
            updateNavbarColor(val) {
                this.navbarColor = val;
                this.isNavbarDark = val !== "#fff";
            },
            handleWindowResize(event) {
                this.windowWidth = event.currentTarget.innerWidth;
                this.setSidebarWidth();
            },
            async setSidebarWidth() {
                if (this.windowWidth < 1200) {
                    await this.toggleIsSidebarActive(false);
                    await this.updateSidebarWidth('no-sidebar')
                } else if (this.windowWidth < 1200) {
                    await this.updateSidebarWidth('reduced')
                } else {
                    await this.toggleIsSidebarActive(true);
                }
            },
            setDates() {
                this.startDate = new Date(this.daterange.startDate);
                this.endDate = new Date(this.daterange.endDate);
            }
        },
        created() {
            this.setSidebarWidth();
            this.setDates();
            if (this.navbarColor === "#fff" && this.isThemeDark) {
                this.updateNavbarColor("#10163a")
            } else {
                this.updateNavbarColor(this.navbarColor)
            }
        },
        components: {
            VxSidebar: () => import('@/layouts/components/vx-sidebar/VxSidebar.vue'),
            Navbar: () => import('./components/Navbar.vue'),
        },

    }
</script>
